import { findDeepGetActivityOfTask } from '../../../../views/lookahead/planification/index.helper';
import {
  applyVisualConflictStatusToGanttTasks,
  detectUnfitTaskDates
} from './utils';

const alreadyProcessedActivities = new Set();

const isMostCriticalDate = (task) => {
  if (task._skipConflictUpdate) return;
  const activityReference = findDeepGetActivityOfTask(
    window.activities,
    'id',
    task?.id
  );

  if (!activityReference) return;
  const activityId = activityReference.unique_id;
  if (alreadyProcessedActivities.has(activityId)) return;
  alreadyProcessedActivities.add(activityId);
  task._skipConflictUpdate = true;

  const updatedLeafTasks = detectUnfitTaskDates(activityReference);

  applyVisualConflictStatusToGanttTasks(
    updatedLeafTasks,
    window.ganttVisualization,
    activityReference
  );

  setTimeout(() => {
    delete task._skipConflictUpdate;
    alreadyProcessedActivities.delete(activityId);
  }, 0);

  return task;
};

const detectChangeTask = (task, previousTaskVerify) => {
  if (
    previousTaskVerify.start_date.getTime() !== task.start_date.getTime() ||
    previousTaskVerify.end_date.getTime() !== task.end_date.getTime() ||
    previousTaskVerify.duration !== task.duration
  ) {
    return true;
  }
  return false;
};

export { isMostCriticalDate, detectChangeTask };
